var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFingerprintZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.24,
    height: 18.6,
    viewBox: "0 0 21.24 18.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fingerprint-zoom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-zoom"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.3,2.1c.4.1.7.1,1.1.2a6.74,6.74,0,0,1,3.8,2.4.1.1,0,0,0,.1.1l-.9.6A6,6,0,0,0,5.9,3.9a.76.76,0,0,0-.2-.4c-.1-.2-.2-.3-.3-.5a6.12,6.12,0,0,1,1.2-.5l1.5-.3h.1A4.1,4.1,0,0,1,9.3,2.1Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,12.2V11.1H3.1A1.22,1.22,0,0,0,4.2,9.8V8.5A4.35,4.35,0,0,1,7.7,4.7a4.52,4.52,0,0,1,5.5,3.8V9.6a1.49,1.49,0,0,0,.2.9c-.2.1-.5.1-.7.2-.4.1-.4.1-.5-.3a2.77,2.77,0,0,1-.1-.9,4.4,4.4,0,0,0-.2-1.6A3.34,3.34,0,0,0,8.4,5.6a3.72,3.72,0,0,0-3,3.1,4.82,4.82,0,0,0,0,1.2,2.28,2.28,0,0,1-1.9,2.3A9.63,9.63,0,0,1,1.8,12.2Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2,13.5h1.1A4.4,4.4,0,0,1,11.6,17a4.56,4.56,0,0,1-5,.5,4.34,4.34,0,0,1-2.3-4h1a3.42,3.42,0,0,0,3.6,3.4A3.49,3.49,0,0,0,12.2,13.5Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,10.7H9.7V9.1a.88.88,0,0,0-.8-.9,1,1,0,0,0-1,.7v1.8H6.8V8.8a2,2,0,0,1,3.9.3A8.08,8.08,0,0,1,10.8,10.7Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8,11.9H7.9v1.5a.9.9,0,0,0,.9.9.92.92,0,0,0,.9-1V11.8h1v1.9a1.9,1.9,0,0,1-2.1,1.6,2,2,0,0,1-1.8-1.9Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,3.7a2.7,2.7,0,0,0,.7.8A5.78,5.78,0,0,0,3.3,6.8a7.89,7.89,0,0,0-.5,3H1.7a7.45,7.45,0,0,1,.6-3.3A6.5,6.5,0,0,1,4.4,3.7Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,17.8a2.7,2.7,0,0,0,.8-.7,5.9,5.9,0,0,0,4.4,2.2,4.1,4.1,0,0,0,.1,1.1,6.87,6.87,0,0,1-2.4-.5A6.58,6.58,0,0,1,3.3,17.8Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8,13.5H2.9a5.92,5.92,0,0,0,.7,2.9c-.3.2-.6.3-.9.5A6.92,6.92,0,0,1,1.8,13.5Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,5.8a5,5,0,0,1,.5,1.3c-.4.1-.7.2-1,.3-.2-.4-.3-.7-.5-1.1A9.29,9.29,0,0,1,15,5.8Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,7a5.93,5.93,0,0,1,7.8-3,6,6,0,0,1,3,7.8,6,6,0,0,1-7.8,3A6,6,0,0,1,11.3,7Zm.8.4a5.17,5.17,0,0,0,2.5,6.7,5.08,5.08,0,0,0,6.7-2.5,5.17,5.17,0,0,0-2.5-6.7A5,5,0,0,0,12.1,7.4Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,17.6l-.6-1.5a.47.47,0,0,1,.9-.3l.6,1.5a.45.45,0,0,1-.3.6h-.3Q19.4,17.75,19.4,17.6Z",
    transform: "translate(-1.55 -1.95)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintZoom);
export default __webpack_public_path__ + "static/media/fingerprint-zoom.26ecd5eb881b81136e0cccb9c5df2dbd.svg";
export { ForwardRef as ReactComponent };